
const CONFIG = {
  languages: [
    { flag: 'gb', language: 'en', title: 'English' },
    { flag: 'es', language: 'es', title: 'Spanish' },
    { flag: 'fr', language: 'fr', title: 'French' },
    { flag: 'nl', language: 'nl', title: 'Dutch' }
  ],

  showLink: true,
  showHowTo: false, // false
  showEcommTour: false, // ecomm tour
  infoPanel1: false,
  infoPanel2: false,
  infoPanel3: false,

  primaryDomain: true,

  showHelpLink: {
    website: false,
    email: false,
    SEO: false,
    scorecard: false,
    yolawebsite: false,
    sitepluswebsite: false,
    domainregistration: false,
    flockemail: false
  },

  // Services to Hide
  hideService: {
    website: false,
    email: false,
    SEO: false,
    scorecard: false,
    yolawebsite: false,
    sitepluswebsite: false,
    domainregistration: false,
    flockemail: false,
    businessProfile: true,
    businessProfileSidebar: false,
    templatePicker: true,
    totalchatbotswebchat: false
  },

  showFooterText: true,

  // Show or hide website depending if is DIFM or not
  showWebsiteByDIFM: {
    false: false,
    true: false
  },

  showPolicy: false,

  // domain registration contacts permissions
  administration: {
    create: false,
    edit: true,
    show: true
  },

  registration: {
    create: true,
    edit: true,
    show: true
  },

  technical: {
    create: false,
    edit: true,
    show: true
  },

  billing: {
    create: false,
    edit: false,
    show: true
  }
}

export default {
  CONFIG: CONFIG
}
